import { render, staticRenderFns } from "./QrCodeReaderComponent.vue?vue&type=template&id=3c4cd385&"
import script from "./QrCodeReaderComponent.vue?vue&type=script&lang=js&"
export * from "./QrCodeReaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeReaderComponent.vue?vue&type=style&index=0&id=3c4cd385&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports